import { z } from 'zod';
import { PartnerNewsAdminSchema } from '../../entities/partner-news/partner-news.schema';
/**
 * List Partner News (superadmin)
 * GET /api/v2/admin/partner-news
 */ export const ListPartnerNewsAdminResponseSchema = z.object({
    data: z.array(PartnerNewsAdminSchema)
});

//# sourceMappingURL=list-partner-news-admin.schema.js.map